import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { ROOT_STATE } from '@store/store.types';

const useAppSelector: TypedUseSelectorHook<ROOT_STATE> = useSelector;

export default useAppSelector;
